<h1 mat-dialog-title>{{title}}</h1>
<div class="row">
  <div class="offset-3">
  <div mat-dialog-content>
    <youtube-player [videoId]="id" suggestedQuality="highres"></youtube-player>
  </div>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="cancel()">Close</button>
</div>
